import {
    HStack,
    Box,
    InputGroup,
    InputLeftElement,
    Input,
    InputRightElement,
    IconButton,
    Icon,
    StackDivider,
    Tooltip,
    VStack,
    Checkbox,
} from '@chakra-ui/react';
import { PiMagicWand } from 'react-icons/pi';
import { BsArrowRightShort } from 'react-icons/bs';
import { ToolbarItemViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';

export function createDocumentToolbarView(
    config: ReportingViewBaseConfig
): React.FC<ToolbarItemViewProps> {
    return (props) => {
        return (
            <HStack
                id="selection-toolbar"
                borderRadius="md"
                bg="black"
                onMouseDown={(e) => e.stopPropagation()}
            >
                <HStack
                    bg="whiteAlpha.200"
                    borderRadius="md"
                    p={1}
                    boxShadow="lg"
                    spacing={1}
                    borderWidth={1}
                    borderColor="whiteAlpha.300"
                    divider={
                        <StackDivider borderColor="whiteAlpha.200" borderWidth={1} />
                    }
                >
                    <Box as="form" {...props.ask.form.getFormElementProps()} m={0}>
                        <VStack spacing={1} alignItems="flex-start">
                        <InputGroup size="sm">
                            <InputLeftElement>
                                <Icon
                                    color="whiteAlpha.300"
                                    fontSize="lg"
                                    as={PiMagicWand}
                                />
                            </InputLeftElement>
                            <Input
                                {...props.ask.input}
                                autoFocus={true}
                                color="whiteAlpha.800"
                                minW="16rem"
                                placeholder="Ask AI"
                                borderRadius="md"
                                border="none"
                                bg="whiteAlpha.50"
                                _placeholder={{ color: 'whiteAlpha.300' }}
                                _focus={{ outline: 'none', boxShadow: 'none' }}
                            />
                            <InputRightElement>
                                <IconButton
                                    {...props.ask.button}
                                    aria-disabled={!props.ask.isSubmittable}
                                    borderRadius="full"
                                    aria-label="ask"
                                    icon={<Icon fontSize="lg" as={BsArrowRightShort} />}
                                    size="xs"
                                    bg="whiteAlpha.900"
                                    color="blackAlpha.900"
                                    opacity={1}
                                    _disabled={{ opacity: 0.25, cursor: 'default' }}
                                    _hover={{
                                        bg: 'whiteAlpha.900',
                                        color: 'blackAlpha.900',
                                    }}
                                />
                            </InputRightElement>
                        </InputGroup>
                        <Checkbox
                                {...props.ask.currentThread}
                                fontSize="xs"
                                color="whiteAlpha.800"
                            >
                                Current Chat
                        </Checkbox>
                        </VStack>
                    </Box>
                    <HStack spacing={1}>
                        {props.menu.map((item) => (
                            <Tooltip
                                key={item.id}
                                placement="bottom"
                                openDelay={300}
                                px={2}
                                py={1}
                                bg="gray.50"
                                color="gray.900"
                                shouldWrapChildren={true}
                                label={item.description}
                            >
                                <IconButton
                                    {...item.button}
                                    aria-label={item.description}
                                    size="sm"
                                    color="whiteAlpha.700"
                                    icon={
                                        item.Icon ? (
                                            <Icon fontSize="lg" as={item.Icon} />
                                        ) : undefined
                                    }
                                    variant="ghost"
                                    bg="none"
                                    _hover={{ bg: 'whiteAlpha.50' }}
                                />
                            </Tooltip>
                        ))}
                    </HStack>
                </HStack>
            </HStack>
        );
    };
}
